'use client'

import { Button } from '@qr-front/ui/components/Button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@qr-front/ui/components/Dialog'
import { useAtom } from 'jotai'
import { useTranslations } from 'next-intl'

import { isValidationErrorDialogOpenAtom } from '../../generatorState'

export const ValidationErrorDialog = () => {
	const [isOpen, setIsOpen] = useAtom(isValidationErrorDialogOpenAtom)
	const t = useTranslations()

	return (
		<Dialog open={isOpen} onOpenChange={setIsOpen}>
			<DialogContent
				closeButtonLabel={t('public__qr__common__close')}
				usePortal={false}
				className="max-w-[350px] p-0 desktop:max-w-[400px]"
			>
				<div className="p-6 desktop:p-8">
					<DialogHeader>
						<DialogTitle>
							{t('public__api__errors__publish__validation')}
						</DialogTitle>
					</DialogHeader>
					<div className="flex flex-col items-center gap-2">
						<p className="text-grey-60 type-body-medium text-center text-dark-grey">
							{t(
								'public__qrBuilder__validationModal__maliciousUrls__description',
							)}
						</p>
					</div>
					<div className="mt-8 flex flex-col flex-wrap gap-6 tablet:flex-row">
						<Button
							className="grow"
							size="large"
							onClick={() => setIsOpen(false)}
						>
							{t('public__qr__account__popup__deactivate2fa__success__button')}
						</Button>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}
